export default "__VITE_ASSET__DC_VY3QL__"